import { computed, makeObservable } from 'mobx';
import CalendarEvent from './CalendarEvent';

class HolidayEvent extends CalendarEvent {
  constructor(other) {
    super();

    makeObservable(this, {
      backgroundColor: computed,
      textColor: computed,
      borderColor: computed
    });
    this.merge(other);
  }

  get backgroundColor() {
    return '#00B7B3';
  }

  get textColor() {
    return '#FFFFFF';
  }

  get borderColor() {
    return '#00B7B3';
  }
}

export default HolidayEvent;
